
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

const sizes = [
  'size-1',
  'size-2',
  'size-1',
  'size-1',
  'size-1',
  'size-2',
  'size-1',
];

export default BaseCmsBlock.extend({
  name: 'InformationNetworkWithIconBlock',

  methods: {
    getClasses: function (index) {
      const list = [
        sizes[index % 7],
      ];

      return list.join(' ');
    },
  },
});
